import React from "react";
import {
	CloseBtn,
	ModalBody,
	ModalBox,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalText,
	ModalTitle,
} from "views/components/modals/common/common.component";
import {ReactComponent as IconInfo} from "assets/img/icon/icon-info-navy-blue.svg";
import {ReactComponent as IconClose} from "assets/img/icon/close.svg";
import {PrimaryButton, SecondaryButton} from "views/components/style";
import {Modal} from "@mui/material";
import {observer} from "mobx-react";
import {useViewController} from "data/services/locator";
import {Bindings} from "data/constants/bindings";
import {IConfirmModalController} from "views/components/modals/confirm_modal/confirm_modal.controller";
import {ModalType} from "data/enums";
import {eq, get} from "lodash";
import styled from "@emotion/styled";
import {media} from "assets/css/media";

const ConfirmModalFooter = styled(ModalFooter)`
	display: flex;
	flex-direction: row;

	@media (max-width: ${media.mobile}) {
		flex-direction: column;
	}

	margin-top: 10px;

	.confirm_modal_btn {
		width: 220px;

		@media (max-width: ${media.mobile}) {
			width: 295px;
		}
	}
`;

export const ConfirmModal: React.FC = observer(() => {
	const {i18n, visibleModal, modalContent, close} = useViewController<IConfirmModalController>(
		Bindings.ConfirmModalController
	);

	const title = i18n.t("modal.confirm.title", "Are you sure?");
	const message = get(modalContent, "message", "");
	const callback = get(modalContent, "callback", undefined);
	const modalType = get(modalContent, "type", "leave");

	const isRemoveModal = eq(modalType, "remove");

	const showPrompt = eq(ModalType.CONFIRM, visibleModal);

	if (!showPrompt) {
		return null;
	}

	return (
		<Modal open={showPrompt}>
			<ModalBox>
				<ModalContent>
					<ModalHeader>
						<IconInfo />
					</ModalHeader>
					<ModalBody>
						<ModalTitle style={{marginBottom: 25, marginTop: 15}}>{title}</ModalTitle>
						<ModalText>{message}</ModalText>
					</ModalBody>
					<CloseBtn onClick={close}>
						<IconClose />
					</CloseBtn>
					<ConfirmModalFooter>
						<SecondaryButton
							onClick={callback}
							size="large"
							className="confirm_modal_btn">
							{isRemoveModal
								? i18n.t("modal.confirm.delete_button", "Delete")
								: i18n.t("modal.confirm.leave_button", "Leave")}
						</SecondaryButton>
						<PrimaryButton onClick={close} size="large" className="confirm_modal_btn">
							{isRemoveModal
								? i18n.t("modal.confirm.close_button", "Close")
								: i18n.t("modal.confirm.stay_button", "Stay")}
						</PrimaryButton>
					</ConfirmModalFooter>
				</ModalContent>
			</ModalBox>
		</Modal>
	);
});
